import { Component, HostListener, OnInit } from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';

import { MenuService } from './core/services/menu.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

	isAuthenticated: boolean;

	constructor(public menuService: MenuService,
		public oktaAuth: OktaAuthService) {

		this.oktaAuth.$authenticationState.subscribe(
			(isAuthenticated: boolean) => this.isAuthenticated = isAuthenticated);
	}

	async ngOnInit() {

		this.isAuthenticated = await this.oktaAuth.isAuthenticated();
	}

	openMenu(direction) {

		this.menuService.openMenu(direction);
	}

	hideMenu() {

		this.menuService.hideMenu();
	}

	swipeHandler(event, direction) {

		if (!event.target.closest('.inspection')) {
			this.menuService.swipeHandler(direction);
		}
	}

	@HostListener('contextmenu', ['$event'])
	onRightClick(event) {
		if (event.target.tagName === 'IMG') {
			event.preventDefault();
		}
	}
}
